export const enableMakeActiveProduct = ({
  isOwner,
  isPaid,
  isPrivateLabel,
  isIxOneCaptured,
} = {}) => {
  return isOwner && !isPaid && !isPrivateLabel && !isIxOneCaptured;
};

export const disableMakeActiveProduct = ({
  isOwner,
  isPaid,
  isPrivateLabel,
  isIxOneCaptured,
  status,
} = {}) => {
  return (
    !isOwner ||
    isPaid ||
    isPrivateLabel ||
    isIxOneCaptured ||
    status?.toLowerCase() === 'active'
  );
};

export const disableStatusSelection = ({
  valueOption,
  isOwner,
  isPaid,
  isPrivateLabel,
  isIxOneCaptured,
}) => {
  const isActiveValueOption = valueOption?.toLowerCase() === 'active';

  if (isOwner) {
    return (
      isActiveValueOption &&
      enableMakeActiveProduct({
        isOwner,
        isPaid,
        isPrivateLabel,
        isIxOneCaptured,
      })
    );
  }
  return isActiveValueOption && !isOwner;
};
